module.exports = __webpack_public_path__ + "img/gh-30513.asm.2d20bd19.jpg";